import {
  ActionIcon,
  Box,
  Button,
  Checkbox,
  Flex,
  Group,
  Menu,
  Table,
  Text,
  TextInput,
  ThemeIcon,
  Title,
} from '@mantine/core'
import adminSettingsClasses from './AdminSettings.module.css'
import {
  IconDots,
  IconDotsVertical,
  IconGripVertical,
  IconSearch,
} from '@tabler/icons-react'
import { useAppDispatch } from '@hooks/redux'
import { useEffect } from 'react'
import { setActiveSection } from '@redux/site/siteSlice'
import classes from './Stages.module.css'

const MOCK_DATA = [
  {
    name: 'Cold',
    color: '#9EAAB7',
  },
  {
    name: 'Engage',
    color: '#ACECCE',
  },
  {
    name: 'Qualify',
    color: '#BBAEF5',
  },
  {
    name: 'Pitch',
    color: '#94ABCA',
  },
  {
    name: 'Manage objections',
    color: '#F1A09D',
  },
  {
    name: 'Close',
    color: '#D6E8E9',
  },
  {
    name: 'Nurture',
    color: '#BCD6AE',
  },
]

export const Stages = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setActiveSection('Stages'))
  })

  const rows = MOCK_DATA.map((item) => (
    <Table.Tr key={item.name}>
      <Table.Td style={{ whiteSpace: 'pre' }}>
        <Group gap={5}>
          <ThemeIcon variant="transparent" color="gray.7">
            <IconGripVertical size={22} />
          </ThemeIcon>
          <Box
            className={classes.Stages__color}
            style={{ backgroundColor: item.color }}
          />
          <Text size="sm" ml={5}>
            {item.name}
          </Text>
        </Group>
      </Table.Td>
      <Table.Td style={{ whiteSpace: 'pre' }}>
        <Menu>
          <Menu.Target>
            <ActionIcon variant="default" radius="xl" aria-label="Options">
              <IconDots style={{ width: '70%', height: '70%' }} stroke={1.5} />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item color="dark">Edit</Menu.Item>
            <Menu.Item color="red" onClick={() => {}}>
              Delete
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Table.Td>
    </Table.Tr>
  ))

  return (
    <>
      <Flex justify="flex-end" p="xs">
        <Button>Add Stage</Button>
      </Flex>
      <Table withRowBorders={false} verticalSpacing="xs">
        <Table.Thead>
          <Table.Tr className={adminSettingsClasses.AdminSettings__thead}>
            <Table.Th key={`columns-1`} style={{ whiteSpace: 'pre' }}>
              <Text size="xs" c="black">
                Name
              </Text>
            </Table.Th>

            <Table.Th>
              <Text size="xs">7 results</Text>
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>
    </>
  )
}
